@if (articles.length) {
<div class="discover">
    <div class="discover__title">{{ lang.data[langTitle] }}</div>
    <div class="discover-grid">
        @for (article of articles | slice:0:2; track article) {
        <a
            class="discover-card pointer"
            routerLink="/article/{{ article.slug }}"
        >
            <!--            <div class="discover-card-category">{{ article.categoryTitle }}</div>-->
            <div class="discover-card-title">{{ article.title }}</div>
        </a>
        }
    </div>
</div>
}
